import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { connect } from 'react-redux';

import RaceInfo from '~/components/RaceInfo';
import RoundLegNavigator from '~/components/RoundNavigation/RoundLegNavigator';
import TabNavigation from '~/components/RoundNavigation/TabNavigation';
import StartList from '~/components/StartList';
import RoundLeg from '~/containers/RoundLeg';

import LegTips from '../LegTips';

export const RenderRace = ({
  race,
  roundSlug,
  bet_type,
  leg_number,
  view,
  location,
}) => (
  <Fragment>
    <TabNavigation
      leg_number={leg_number}
      bet_type={bet_type}
      roundSlug={roundSlug}
      location={location}
    />

    {view === 'startlista' ? (
      <StartList race={race} betType={bet_type} />
    ) : (
      <LegTips leg_number={leg_number} bet_type={bet_type} race={race} />
    )}
  </Fragment>
);

const Legs = ({ slug, leg_number, round, view, location }) => (
  <Fragment>
    <RoundLegNavigator round={round} slug={slug} />

    <RoundLeg
      slug={slug}
      leg={leg_number}
      render={({ race }) => (
        <Fragment>
          <RaceInfo race={race} primaryBetType={round.bet_type} />
          <RenderRace
            location={location}
            race={race}
            legs={[{ bet_type: round.bet_type }]}
            roundSlug={slug}
            bet_type={round.bet_type}
            leg_number={leg_number}
            view={view}
          />
        </Fragment>
      )}
    />
  </Fragment>
);

Legs.propTypes = {
  slug: PropTypes.string.isRequired,
  leg_number: PropTypes.number.isRequired,
  round: PropTypes.object.isRequired,
  view: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  location: state.location,
});

export default connect(mapStateToProps)(Legs);
